import { ReactNode } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";

type GridCardWithActionsProps = {
  actions?: ReactNode;
  /** When defined, renders a selection checkbox in the top-left corner. */
  selected?: boolean;
  onSelectedChange?: (checked: boolean) => void;
  children: ReactNode;
};

/** Positionne le menu ⋮ (haut droite) et la case à cocher (haut gauche) d'une carte grille. */
export function GridCardWithActions({
  actions,
  selected,
  onSelectedChange,
  children,
}: GridCardWithActionsProps) {
  const selectable = typeof onSelectedChange === "function";

  if (!actions && !selectable) {
    return <>{children}</>;
  }

  return (
    <div
      className={cn(
        "relative inline-flex max-w-[300px] rounded-sm",
        selected && "ring-2 ring-primary ring-offset-1",
      )}
    >
      {selectable && (
        <div
          className="absolute left-2 top-2 z-10 shadow-sm"
          onClick={(event) => event.stopPropagation()}
        >
          <Checkbox
            checked={!!selected}
            onCheckedChange={(checked) => onSelectedChange?.(checked === true)}
            aria-label="Select row"
            className="bg-[#def2ff]/30 data-[state=checked]:bg-primary"
          />
        </div>
      )}
      {actions && (
        <div
          className="absolute right-1 top-1 z-10 rounded-md bg-white shadow-sm"
          onClick={(event) => event.stopPropagation()}
        >
          {actions}
        </div>
      )}
      {children}
    </div>
  );
}
